<template>
  <div class="image-view">
    <div class="image-view__header">
      <span>{{ title }}</span>
      <span @click="$emit('close')">
        <img :src="require('@/assets/img/close-x.png')" class="close" />
      </span>
    </div>
    <img :src="imageUrl" />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class App extends Vue {
  @Prop({ default: '' }) readonly imageUrl!: string;
  @Prop({ default: '' }) readonly title!: string;
}
</script>

<style lang="scss" scoped>
.image-view {
  width: 100vw;
  height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;

  > img {
    width: 100%;
  }

  &__header {
    position: absolute;
    top: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    padding: 2rem;
    display: flex;
    justify-content: space-between;
    color: white;
    font-size: 1.4rem;
    .close {
      height: 14px;
      width: 14px;
      cursor: pointer;
    }
  }
}
</style>
